import { PostCollateralDTO } from 'api/application/createPostCollateralDTO'
import axios, { AxiosError } from 'axios'
import config from 'config'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'
import { defaultLosJsonHeaders } from '../requestHeaders'

export default async function postApplicationCollateral(
    uuid: string,
    collateral: PostCollateralDTO,
) {
    try {
        const { data } = await axios.post(
            `${config.API_BASE_URL}/api/v3/applications/${uuid}/collaterals/`,
            collateral,
            {
                withCredentials: true,
                headers: defaultLosJsonHeaders(),
            },
        )

        return data
    } catch (error) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to get post application collaterals: ${axiosError.message}`,
            axiosError,
            { application: { uuid } },
        )

        throw new Error(axiosError.message)
    }
}
